import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from '../components/auth/Login';
import Accounts from '../components/accounts/Accounts';
import FundWallet from '../components/fund-wallet/FundWallet';
import Overview from '../components/overview/Overview';
import Subscribe from '../components/subscribe/Subscribe';
import App from '../App';
import ForgotPassword from '../components/auth/ForgotPassword';
import ResetPassword from '../components/auth/ResetPassword';
import { PrivateRoute } from './PrivateRoute';
import Profile from '../components/profile/Profile';
import SubscribeWithMac from '../components/subscribe/mac/SubscribeWithMac';

const Routes = () => (
  <App>
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      <Route exact path="/reset-password/:token" component={ResetPassword} />
      <PrivateRoute exact path="/accounts" component={Accounts} />
      <PrivateRoute exact path="/fund-wallet" component={FundWallet} />
      <PrivateRoute exact path="/" component={Overview} />
      <PrivateRoute exact path="/profile" component={Profile} />
      <PrivateRoute exact path="/subscribe" component={Subscribe} />
      <Route exact path="/subscribe/:macid" component={SubscribeWithMac} />
    </Switch>
  </App>
);

export default Routes;
